<template>
  <ValidationObserver slim v-slot="{ handleSubmit, invalid }" vid="emails" ref="observer">
    <form :data-vv-scope="formScope" @submit.prevent="handleSubmit(update)">
      <BaseLayoutSpaced relaxed>
        <div>
          <BaseLayoutSpaced>
            <ValidationProvider
              v-for="field in formFieldsWithDefaults"
              :key="field.name"
              :name="field.name"
              :vid="field.name"
              :rules="field.validation"
              v-slot="{ errors, failed }"
              slim
            >
              <BaseFormGroup>
                <BaseFormLabel v-if="field.label" :for="`${_uid}-${field.name}`">
                  {{ field.label }} <template v-if="field.validation.required"> * </template>
                </BaseFormLabel>
                <Component
                  v-model="data[field.name]"
                  :is="field.component"
                  :disabled="submitting"
                  v-bind="{
                    ...field.options.props,
                    ...field.options.attrs,
                  }"
                  :invalid="failed"
                  :id="`${_uid}-${field.name}`"
                />
                <BaseFormInlineMessage v-if="failed" danger>
                  {{ errors[0] }}
                </BaseFormInlineMessage>
              </BaseFormGroup>
            </ValidationProvider>
          </BaseLayoutSpaced>
        </div>
        <div class="flex space-x-2 py-1 items-baseline">
          <BaseButton primary type="submit" :disabled="invalid || submitting">
            <span v-if="!submitting">Ενημέρωση</span>
            <Loader v-else small inverse />
          </BaseButton>
        </div>
      </BaseLayoutSpaced>
    </form>
  </ValidationObserver>
</template>

<script>
import { mapActions } from 'vuex';
import { HTTP_UNPROCESSABLE_ENTITY } from '@/api/http-response-codes';
import veeValidateErrorsMixin from '@/mixins/veeValidateErrorsMixin';

const defaultField = {
  component: null,
  label: '',
  name: '',
  options: {},
  validation: {},
};

const defaultData = {
  name: null,
  description: null,
};

export default {
  name: 'TabGeneral',
  mixins: [veeValidateErrorsMixin],
  props: {
    campaign: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    data: { ...defaultData },
    formScope: 'update-campaign',
    submitting: false,
  }),
  computed: {
    formFieldsWithDefaults() {
      const fields = [
        {
          component: 'BaseFormInput',
          label: 'Όνομα',
          name: 'name',
          options: {
            attrs: {
              name: 'name',
              min: 5,
              class: 'w-full',
            },
          },
          validation: {
            required: true,
          },
        },
        {
          component: 'BaseFormTextarea',
          label: 'Περιγραφή',
          name: 'description',
          options: {
            attrs: {
              name: 'description',
            },
          },
          validation: {
            max: 512,
          },
        },
      ];

      return fields.map((x) => ({ ...defaultField, ...x }));
    },
  },
  created() {
    this.setData();
  },
  watch: {
    campaign: {
      handler() {
        this.setData();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions('ui/campaigns', ['updateCampaign']),
    setData() {
      Object.keys(defaultData).forEach((prop) => {
        if (this.campaign[prop] !== undefined) {
          this.data[prop] = this.campaign[prop];
        }
      });
    },
    async update() {
      const submitWithErrorHandling = this.handleFormErrors(this.updateCampaign);

      this.submitting = true;

      await submitWithErrorHandling({
        campaignId: this.campaign.id,
        campaignData: this.data,
      });

      this.submitting = false;
    },
    handleFormErrors(fn) {
      return (...params) =>
        fn(...params)
          .then(() => {
            if (this.closeOnSuccess) {
              this.$refs.modal.doClose();
            }
          })
          .catch(({ status, data } = {}) => {
            // do sth with the error!
            if (status && status === HTTP_UNPROCESSABLE_ENTITY) {
              this.observer = this.$refs.observer;
              this.addServerErrors(data.errors);
            }
          });
    },
  },
};
</script>
